import React from 'react'

import 'bootstrap/dist/css/bootstrap.min.css';

const Quickaccess = () => {
  return (
    <div className="container py-5">
<div className="row row-cols-1 row-cols-md-3 g-4">
  {/* Card 1 */}
  <div className="col-md-4">
    <div className="card p-4 m-4 rounded-3 shadow">
      <div className="card-body">
        <h5 className="card-title">Job Placement Portal</h5>
        <p className="card-text">
        
          This is an example card with padding, margin, rounded corners, and box shadow.
        </p>
      </div>
    </div>
  </div>

  {/* Card 2 */}
  <div className="col-md-4">
    <div className="card p-4 m-4 rounded-3 shadow">
      <div className="card-body">
        <h5 className="card-title">Training and Education Programmes</h5>
        <p className="card-text">
          This is another example card with similar styling and layout.
        </p>
      </div>
    </div>
  </div>

  {/* Card 3 */}
  <div className="col-md-4">
    <div className="card p-4 m-4 rounded-3 shadow">
      <div className="card-body">
        <h5 className="card-title">Digital Certificate Access</h5>
        <p className="card-text">
          This is the third example card with consistent padding and styling.
        </p>
      </div>
    </div>
  </div>
</div>
</div> 
  )
}

export default Quickaccess